import Repository from '../Repository';

export default {

	getRoles() {
		var response = Repository.get('Role/GetRoles', {});
		return response;
	}

}
